import { extractIns, extractJSONIns } from './index';

export const extractOpenDmp = (data) => {
  const {
          addAccessAuthorization: {
            value: addAccessAuthorization,
          } = {},
        } = data;
  const ins = extractIns(data);
  
  return { addAccessAuthorization, ...ins };
}

export const extractJSONOpenDmp = (data) => {
  const {
          addAccessAuthorization,
        } = data;
  const ins = extractJSONIns(data);
  
  return { addAccessAuthorization, ...ins };
}